import React from "react";
import YesOrNoFields from "./YesOrNoFields";
import BasicFormFields from "./BasicFormFields";
import PatientDetails from "./PatientDetails";
import CompanyDetails from "./CompanyDetails";
import CheckboxGroup from "./CheckBoxGroup";
import RadioBoxGroup from "./RadioBoxGroup";
import UnOrderedList from "./UnOrderedList";
import LabelField from "./LabelField";
import ResultSummary from "./ResultSummary";
import ChartDocument from "./ChartDocument";
import LabPanel from "./LabPanel";
import NewYesOrNoFields from "./NewYesOrNoFields";
import NewYesNo from "./NewYesNo";
import YesAnswersDisplay from "./YesAnswersDisplay";
import CertificationForm from "./CertificationForm";
import NewYesOrNo from "./NewYesOrNo";
import AdulterationForm from "./AdulterationForm";
import ProviderSignOff from "./ProviderSignOff";
import TrialYesOrNoTable from "./TrialYesOrNoTable";
import DragDropFileUpload from "./DragDropFileUpload";
import AudiogramTable from "./AudiogramTable";
import NewPatientDetails from "../../../../../EmrProviderContainer/NewUIEmrPage/NewPatientDetails";
import ActivityPopUpPatientDetails from "../../../../../EmrProviderContainer/NewUIEmrPage/ActivityPopUpPatientDetails";
import ResultNotesWithSendMessage from "./ResultNotesWithSendMessage";
import SendMessageButton from "./SendMessageButton";
import InlineValueText from "./InlineValueText";
// import NewPatientDetails from "../../../../../EmrProviderContainer/NewUIEmrPage/NewPatientDetails";

const SwitchFields = ({item,...props}) => {
  switch (item.type) {
    case "ResultNotesWithSendMessage":
      return <ResultNotesWithSendMessage {...item} {...props} />;
    case "SendMessageButton":
      return <SendMessageButton {...item} {...props} />;
    case "InlineValueText":
      return <InlineValueText {...item} {...props} />;
    case "PatientDetails":
      return <ActivityPopUpPatientDetails {...item} {...props}/>
    case "CompanyDetails":
        return <CompanyDetails {...item} {...props}/>
    case "ResultSummary":
      return <ResultSummary {...item} {...props}/>
    case "YesOrNoTable":
          return <YesOrNoFields {...item} {...props}/>
    case "NewYesOrNoTable":
          return <NewYesOrNo {...item} {...props}/>
    case "AdulterationForm":
          return <AdulterationForm {...item} {...props}/>
    case "CheckBoxGroup":
      return <CheckboxGroup  {...item} {...props}/>
    case "radioBoxGroup":
      return <RadioBoxGroup  {...item} {...props}/>
    case "UnorderedList":
      return <UnOrderedList {...item} {...props} />
    case "Label":
        return <LabelField {...item} {...props} />;
    case "ChartDocument":
      return <ChartDocument {...item} {...props} />
    case "LabPanel":
      return <LabPanel {...item} {...props} />
    case "NewYesOrNoFields":
      return <NewYesOrNoFields {...item} {...props} />
    case "NewYesNo":
      return <NewYesNo {...item} {...props} />
    case "YesAnswersDisplay":
      return <YesAnswersDisplay {...item} {...props} />
    case "CertificationForm":
      return <CertificationForm {...item} {...props} />
    case "ProviderSignOff":
      return <ProviderSignOff {...item} {...props} />
    case "TrialYesOrNoTable":
      return <TrialYesOrNoTable {...item} {...props} />
    case "Button":
      return (
        <div className={item.col || ""}>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => item.onClick?.()}
            title={item.disabled && item.disableButtonTitle ? item.disableButtonTitle : (item.title || item.label)}
            disabled={item.disabled}
          >
            {item.label}
          </button>
        </div>
      );
    case "DragDropFileUpload":
      return <DragDropFileUpload {...item} {...props} />
    case "AudiogramTable":
      return <AudiogramTable {...item} {...props} />
    default:
      return <BasicFormFields {...item} {...props}/>;
  }

  
};

export default SwitchFields;